import { createFileRoute } from '@tanstack/react-router';
import { Seo } from '../$portalId/-components/seo';
import { useLingui } from '@lingui/react/macro';
import { Layout } from './-components/layout';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { getLegalContentFn } from '@/lib/server-functions-portal';

export const Route = createFileRoute('/www/selection-criteria')({
	loader: ({ context }) => getLegalContentFn({ data: { type: 'selection-criteria', locale: context.locale } }),
	component: Component,
});

function Component() {
	const { t } = useLingui();
	const html = Route.useLoaderData();

	return (
		<Layout>
			<Header />
			<Seo
				title={t`Selection criteria - Worldcoo`}
				description={t`Selection criteria that Worldcoo uses to verify that entities meet the necessary requirements to ensure the viability of the collaboration.`}
			/>

			<article className="unreset-tailwind mx-auto max-w-4xl p-8" dangerouslySetInnerHTML={{ __html: html }} />

			<Footer />
		</Layout>
	);
}
